import React, { useEffect, useState } from "react";
import { numDifferentiation } from "../../utils";
export default function TermSendMessage({ setMessage, message, sendAfterEnter, send, uploadFile, lastMessage, agentName, botName , totalMsgs }) {
  const [disableInput, setDisableInput] = useState(false)
  const [monthlyExpense, isMonthlyExpense] = useState(false)
  const [loanInput, isLoneInput] = useState(false)
  const [error, setError] = useState(null)

  const fullText = "Help me choose the right plan";
  const [placeholderText, setPlaceholderText] = useState("");
  const [isTyping, setIsTyping] = useState(true);
  const [isFocused, setIsFocused] = useState(false);
  const showAnimatedPlaceholder = totalMsgs === 1 && !isFocused;
  const validateMobile = (e) => {
    setMessage(e.target.value);
  }

  useEffect(() => {
    if (!showAnimatedPlaceholder || !isTyping) return;

    let index = 0;
    const typingInterval = setInterval(() => {
      setPlaceholderText(fullText.slice(0, index + 1));
      index++;

      if (index === fullText.length) {
        clearInterval(typingInterval);
        setIsTyping(false);
      }
    }, 70);

    return () => clearInterval(typingInterval);
  }, [showAnimatedPlaceholder]);

  const handleKeyDown=(e)=>{
    setError(null)
    
    if (e.key == 'Enter') {
      sendAfterEnter(e)
  }
  }
  const sendMsg=(e)=>{
    send()

  }
  return (
    <div className="SendMsgContainer">
          
      <textarea
        value={message}
        style={{
          flex: 1,
          // marginTop: agentName ? 40 : -5
        }}
        className={agentName ? "sendMsgSpaceWithAgent" : ""}
        maxLength={1000}
        placeholder={showAnimatedPlaceholder ? placeholderText : "Type your message here"}     
        label=""
        disabled={!lastMessage || (!botName && !agentName)}
        required
        onFocus={() => setIsFocused(true)}
        onChange={(e) => {
          setIsTyping(false);
          validateMobile(e);
        }} onKeyDown={(e) => handleKeyDown(e)}
      />
      {agentName ?
        <label className="fileInput">
          <input type={'file'} onChange={(event) => uploadFile(event.target.files)}></input>
        </label>
        : null} 
      <button className="SendMsgbutton disable" onClick={sendMsg}>Send</button>
    </div>
  );
}
